module.exports = {
    model: {
        data: {}
    },

    methods: {
        update(data){
            this.model.data = data || {}

            this.refresh()
        }
    }
}